/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { FC } from 'react';

import { LinkBlock } from '@components/common';
import { ImgStyled } from '@components/common/Block/Img';

import { EmdConnectionOptionStyled } from '../styled/EmdConnectionStatusStyled';

interface IProps {
    imgHeight: string;
    imgWidth: string;
    imgSrc: string;
    linkTitle: string;
    onClick: () => void;
};

export const EdmConnectionOption: FC<IProps> = ({ imgHeight, imgSrc, imgWidth, linkTitle, onClick }) => {
    const handleOnClick = () => {
        onClick();
    };

    return (
        <EmdConnectionOptionStyled>
            <ImgStyled className="status-icon" height={imgHeight} src={imgSrc} width={imgWidth} />
            <LinkBlock
                onClick={handleOnClick}
            >
                <span>{linkTitle}</span>
            </LinkBlock>
        </EmdConnectionOptionStyled>
    );
};
